import React from 'react'
import {Container, Row, Col, Button} from "react-bootstrap"
import {Link, useHistory} from "react-router-dom"
import LightSpeed from 'react-reveal/LightSpeed';

import Monopattino1 from "../../style/Img/Monopattini/Monopattino1.jpeg"
import Monopattino2 from "../../style/Img/Monopattini/Monopattino2.jpg"
import Monopattino3 from "../../style/Img/Monopattini/Monopattino3.jpg"




function ListaMonopattini() {

    let history = useHistory();


    return (
        <Container fluid>
            {/* SEZIONE BANNER */}
            <Container fluid id="banner_recovered" className="head-banner text-center text-white">
            <Container>
            <Row>
                <Col>
                    <h1><strong>8-Bit Motors</strong></h1>
                </Col>
            </Row>
        </Container>
        </Container>

        {/* SEZIONE INTRODUZIONE */}
        <Container className=" text-center mt-3">
            
            <h2><strong>Catalogo Motocicli</strong></h2>
            <h3>I nostri motocicli disponibili al noleggio 24/7</h3>
            
        </Container>

        {/* SEZIONE AUTOMOBILI */}
        <Container className="mt-4">
            <Row>
                <Col>
                <LightSpeed left>
                <Link to="/veicoli/specifiche/Monopattino Turbo">
                <img className="d-block w-100" src={Monopattino1} alt="Monopattino Turbo" />
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Monopattino Turbo</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        1€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Monopattino Turbo")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>

            <Row className="mt-4">
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Monopattino"}>
                <img className="d-block w-100" src={Monopattino2} alt="Monopattino" />
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Monopattino</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        1€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Monopattino")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>

            <Row className="mt-4">
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Monopattino con Sella"}>
                <img className="d-block w-100" src={Monopattino3} alt="Monopattino con Sella" />
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Monopattino con Sella</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        1€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Monopattino con Sella")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>
        </Container>
        </Container>
    )
}

export default ListaMonopattini